// src/pages/UserDashboard.jsx
import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import ProfilePage from './ProfilePage';
import DeliveryStatusPage from './DeliveryStatusPage';
import WalletPage from './WalletPage';
import AddOnsPage from './AddOnsPage';
import MyMenu from './MyMenu'; 
// ✅ 1. IMPORT THE NEW DASHBOARD COMPONENT
import DashboardHomePage from './DashboardHomePage'; 
import './UserDashboard.css';

const UserDashboard = () => {
  const location = useLocation();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/user-dashboard' },
    { id: 'profile', label: 'Profile Page', icon: '👤', path: '/user-dashboard/profile' },
    { id: 'my-menu', label: 'My Menu', icon: '📖', path: '/user-dashboard/my-menu' },
    { id: 'delivery', label: 'Delivery Status', icon: '🚚', path: '/user-dashboard/delivery-status' },
    { id: 'addons', label: 'Add Ons', icon: '🍕', path: '/user-dashboard/add-ons' },
    { id: 'wallet', label: 'Wallet', icon: '💰', path: '/user-dashboard/wallet' },
  ];

  return (
    <div className="user-dashboard-container">
      <div className="dashboard-sidebar">
        <div className="sidebar-header">
          <h3>User Dashboard</h3>
        </div>
        <nav className="sidebar-nav">
          <ul>
            {menuItems.map(item => (
              <li key={item.id} className={location.pathname === item.path ? 'active' : ''}>
                <Link to={item.path}>
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="dashboard-main">
        <div className="dashboard-header">
          <div className="breadcrumb">
            <span>Home / Dashboard</span>
          </div>
          <h1>User Dashboard</h1>
        </div>
        
        {/* ✅ 2. USE ROUTES TO DISPLAY THE CORRECT COMPONENT */}
        <div className="dashboard-content">
          <Routes>
            {/* The index route renders when the path is exactly /user-dashboard */}
            <Route index element={<DashboardHomePage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="my-menu" element={<MyMenu />} />
            <Route path="delivery-status" element={<DeliveryStatusPage />} />
            <Route path="add-ons" element={<AddOnsPage />} />
            <Route path="wallet" element={<WalletPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;